import React from 'react'
import { Button, Grid, Container, makeStyles } from '@material-ui/core'
import { useSchwabAuthenticate } from './hooks'

const useStyles = makeStyles({
  formContainer: {
    display: 'flex',
    border: 'var(--border-neutral-thin)',
    borderRadius: 'var(--border-radius-sm)',
    padding: '2rem',
    justifyContent: 'center',
    alignContent: 'center'
  },
  headerText: {
    fontSize: '2rem',
    textAlign: 'center'
  },
  action: {
    display: 'flex',
    justifyContent: 'center',
    '& .__button': {
      borderRadius: 'var(--border-radius-round)',
      border: 'var(--border-neutral-normal)',
      backgroundColor: '#FFF',
      textTransform: 'none',
      padding: '0.5rem 1rem',
      maxHeight: '2.5rem'
    }
  }
})

const Authenticate = () => {
  const classes = useStyles()
  const { handleAuthenticate } = useSchwabAuthenticate()
  return (
    <Container maxWidth='md' style={{ paddingTop: '1rem' }}>
      <div className={classes.formContainer}>
        <Grid container>
          <Grid item xs={12}>
            <h3 className={classes.headerText}>Schwab API</h3>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.action}>
              <Button className={classes.__button} onClick={handleAuthenticate}>Authenticate</Button>
            </div>
          </Grid>
        </Grid>
      </div>
    </Container>
  )
}

export default Authenticate
